module.exports = __webpack_public_path__ + "img/DannHaltApfel.c2cde346.svg";